export const SERVICES = [
  { 
    name: "Artificial Intelligence",
    desc: "Delving on the potential of AI and its practical use in our day-to-day operations.",
    icon: "ai-icon"
  },
  {
    name: "Big Data",
    desc: "Cooperating and managing cloud-based services with scalable data storage and analytics.",
    icon: "big-data-icon"
  },
  {
    name: "Real-Time Bidding",
    desc: "Working closely with RTB hosts who track, measure, analyze and gather real-time results.",
    icon: "rtb-icon"
  },
  {
    name: "Computer Reservation System",
    desc: "CRS platforms storing and retrieving info related to travel, vehicle rentals, and the like.",
    icon: "reservation-icon"
  },
  {
    name: "SFM",
    desc: "Protect your customers and reduce losses from fraud payments.",
    icon: "sfm-icon"
  },
  {
    name: "Game Development",
    desc: "Creating gaming environments that transcend real life experiences, while providing users with new dimensions of fun.",
    icon: "game-dev-icon"
  },
  {
    name: "Affiliate Marketing",
    desc: "Performance-based ad networks that award affiliates for bringing visitors to different sites, and vice versa.",
    icon: "marketing-icon"
  },
  {
    name: "Software Development",
    desc: "Engineering various projects such as software and applications that bring value to users.",
    icon: "software-icon"
  },
];

export const PROJECTS = [
  {
    name: "Adwe.com",
    title: "RTB Platform",
    desc: "Managing a self-coded Real-Time-Bidding Platform which operates with all ad formats for both mobile and desktop users, handling over 5B daily requests globally. Minute after minute, inventory is being bought and sold through auctions, thus allowing both parties (advertisers and publishers) to seamlessly generate revenue.",
    path: "adwe",
    url: "/project/adwe",
    realURL: "https://adwe.com"
  },

  
  {
    name: "Abago.com",
    title: "Flight Search - OTA",
    desc: "Harboring one of the biggest databases of flights all over the world to help people find, compare, and book economical air fares. The systems we integrate take care of rapid search conduct that automatically serves users with the right and most prominent option for their wished travel dates.",
    path: "abago",
    url: "/project/abago",
    realURL: "https://abago.com"
  }
  /*
  {
    title: "Mobile Development",
    desc: "Utilizing our in-house 3D engine for Android and iOS platforms which allows developers to easily create 2D and 3D mobile applications in native Android and iOS platforms. Through continuous upgrades and updates, we make sure that only educational and informational apps are being created for our users.",
    path: "mobile-device",
  }
  */
];


export const MANAGMENT = [
];

export const ADMINISTRATION = [
  
];



// WEBPACK FOOTER //
// ./src/data.js